module.exports = __webpack_public_path__ + "187d8949299e3543360eee815ecbc9cb.svg";